<template>
  <div class="home-box">
    <v-card class="mt-5">
      <v-card-actions v-if="!loading">
        <v-chip x-small class="ma-2" dark color="default">
          {{ activityStatus }}
        </v-chip>
        <p>
          <strong v-if="comments">Comment:</strong> {{ comments }}
        </p>
        <v-spacer></v-spacer>
        <v-btn x-small color="primary" @click="resubmit()">Re-Submit</v-btn>
      </v-card-actions>
      <v-card-actions v-if="role == ('CLUBS_PERFORMANCE_EVALUATION' || 'REGION_CPE_COORDINATOR') &&
        !loading && activityStatus !== 'REJECTED' &&
        activityStatus !== 'APPROVED'
        ">
        <v-row>
          <v-col cols="12" md="12" xs="12">
            <v-text-field v-model="form.pending_comment" outlined dense label="Reject comment">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12" xs="12" v-if="role == 'CLUBS_PERFORMANCE_EVALUATION'">
            <v-checkbox v-model="confirm" label="I confirmed and approve this activity"
              @change="form.pending_comment = ''"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" xs="12">
            <v-btn large color="red" :disabled="loading || !form.pending_comment || confirm" depressed block
              @click="reject()">Reject</v-btn>
            <small>If you need any changes or correction, please add a comment and click reject</small>
          </v-col>
          <v-col cols="12" md="3" xs="12" v-if="role == 'CLUBS_PERFORMANCE_EVALUATION'">
            <v-btn large color="green" :disabled="!confirm" depressed block @click="submit()">Approved</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

import { ActivityService } from "../../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "ActivityEstimationPoints",

  components: {},

  data: () => ({
    loading: false,
    role: localStorage.getItem("role") || null,
    confirmCommentOpen: false,
    updateId: null,
    points: [],
    comments: null,
    form: {
      pending_comment: "",
    },
    key: null,
    uuid: null,
    activityStatus: null,
    confirm: false,
    month:null
  }),

  mounted() {
    this.key = this.$route.params.key;
    this.uuid = this.$route.params.aId;
    this.month = this.$route.params.month;
    this.getPoints();
  },

  methods: {
    submit() {
      this.loading = true;
      ActivityService.ApproveActivity(this.uuid, this.key)
        .then((response) => {
          if (response.data.status_code == 200) {
            location.reload();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    reject() {
      this.loading = true;
      ActivityService.rejectActivity(this.uuid, this.key, this.form)
        .then((response) => {
          if (response.data.status_code == 200) {
            location.reload();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getPoints() {
      this.loading = true;
      ActivityService.getActivityPoints(this.uuid, this.key)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.points = response.data.points;
            this.activityStatus = response.data.status;
            this.comments = response.data.comments;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.points = [];
          this.activityStatus = null;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    resubmit(){
      this.$router.push({ name: 'MonthlyActivityAdd', params: { month: this.month, key : this.key } });
    }

  },
};
</script>
